export default {
  drafts: [],
  draftsLoading: false,
  projectId: null,
  activeDraft: null,
  draftLoading: false,
  draftCreating: false,
  draftMutating: false,
  draftDeletingId: null
}
